'use client';

import { Settings } from '@ghosts-inc/design-system/icons';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Link from '@/components/Link';

export const PreferencesButton = () => {
  const href = '/preferences';

  return (
    <>
      <IconButton
        LinkComponent={Link}
        href={href}
        sx={(theme) => ({
          outline: `1px solid ${theme.palette.lightBorder.default}`,
          display: { mobile: 'flex', tablet: 'none' },
        })}
      >
        <Settings htmlColor="black" sx={{ fontSize: 16 }} />
      </IconButton>
      <Button
        color="buttonLight"
        href={href}
        LinkComponent={Link}
        size="small"
        variant="outlined"
        startIcon={<Settings />}
        sx={{ display: { mobile: 'none', tablet: 'flex' } }}
      >
        Preferences
      </Button>
    </>
  );
};
